import React, {useMemo} from "react";
import {useIntl} from "react-intl";
import PageWrapper from "../../../component/home/HomeContentPage";
import DatasourceIconGroup from "../../../assets/images/home/datasource_icon_group.png";
import * as Page from "../../../component/home/HomeContentPage";

const DataSourceInfoPage: React.FC = () => {
    const intl = useIntl();

    const gradient = useMemo(() => {
        return {
            leftTop: (
                <div className={"w-full h-full"}
                     style={{
                         background: "linear-gradient(180deg, rgba(68, 26, 152, 0.25) 40%, rgba(63, 232, 255, 0.25) 100%)",
                         filter: "blur(150px)"
                     }} />
            ),
            rightBottom: (
                <div className={"w-full h-full"}
                     style={{
                         background: "linear-gradient(180deg, rgba(68, 26, 152, 0.25) 40%, rgba(63, 232, 255, 0.25) 100%)",
                         filter: "blur(150px)"
                     }} />
            )
        }
    }, [])

    return (
        <PageWrapper className={"relative mt-[88px]"}>
            <div>
                <div className={"w-[434px] h-[404px] absolute top-[-353px] left-[-198px]"}>
                    {gradient.leftTop}
                </div>
                <div className={"w-[596px] h-[554px] absolute bottom-[-454px] right-[-441px] rotate-[-132.8deg]"}>
                    {gradient.rightBottom}
                </div>
                <img src={DatasourceIconGroup} alt="Icons" width={433} height={298}/>
            </div>
            <div className={"max-w-[598px] z-10"}>
                <Page.Heading>
                    {intl.formatMessage({id: "i0016"})}
                </Page.Heading>
                <Page.Description className={"mt-[16px]"}>
                    {intl.formatMessage({id: "i0017"})}
                </Page.Description>
                <Page.Comment className={"mt-[8px]"}>
                    {intl.formatMessage({id: "i0018"})}
                </Page.Comment>
                <Page.CheckList className={"mt-[40px]"}>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0019"})}
                    </Page.CheckListItem>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0020"})}
                    </Page.CheckListItem>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0021"})}
                    </Page.CheckListItem>
                </Page.CheckList>
            </div>
        </PageWrapper>
    )
}

export default DataSourceInfoPage;
